<div class="checkbox-group d-flex align-items-center">
    <label [ngClass]="{'disabled' : control.disabled, 'tryb-checkbox': true}">
        <span class="input-label">
            {{ inputLabel }}
        </span>
        <input
            type="checkbox"
            [checked]="control.value"
            (change)="onValueChange()"
            [formControl]="control"
        />
        <span class="checkmark" [ngClass]="{'disabled' : control.disabled}">
            <span
                class="material-icons task_alt"
                *ngIf="control.value"
            ></span>
        </span>
    </label>
</div>
